<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-ticket</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.channelList') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <v-divider vertical  style="margin: 0 15px 0 15px;" />
      <span style="color:rgba(0, 0, 0, 0.54);">{{$t('activity.show')}}</span>
      <v-select
        single-line
        v-if="types"
        v-model="content.ChannelListType"
        :items="types"
        item-text="Name"
        item-value="ID"
        style="margin: 10px 0 0 15px;"
        @change="handleChangeIsModified"
      />
    </v-toolbar>
  </div>
</template>

<script>
  import axios from 'axios'
  import api from '@/services/api'
  import utils from '@/services/utils'
  export default {
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
      DviewLink: null,
      types: null
    }),
    computed: {
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
    },
    mounted() {
      this.getData()
    },
    methods: {
      getData () {
        const enterpriseIDDomain = this.$store.state.app.enterpriseID ? this.$store.state.app.enterpriseID : utils.getDomain()
        api.getAll('contents', false, 1, 100000, '', enterpriseIDDomain.concat('/channel-list-type/')).then(response => {          
          this.types = response
          this.types.unshift({
            ID: '',
            Name: 'ALL'
          })
        })
        api.getAll('contents', false, 1, 100000, '', enterpriseIDDomain.concat('/channel-list/')).then(response => {
          console.log('data', response)
        })
      },      
      handleChangeIsModified () {
        this.$store.state.app.isModified = false
      }
    }
  }
</script>

<style scoped>
</style>

